import React from 'react';

export function StepIdentifiersLabel() {
  return <>Identifikátory</>;
}
